import { render, staticRenderFns } from "./GreatBritainFlag.vue?vue&type=template&id=dd91f28c&"
import script from "./GreatBritainFlag.vue?vue&type=script&lang=js&"
export * from "./GreatBritainFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports